var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#34DC93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7462 41.8668C82.3159 42.2212 83.0627 41.8161 83.0627 41.1579V41.1453C83.0627 37.1453 79.8222 33.9048 75.8222 33.9048C71.8222 33.9048 68.5817 37.1453 68.5817 41.1453C68.5817 41.1579 68.5817 41.1579 68.5817 41.1579C68.5817 41.8288 69.3285 42.2212 69.8981 41.8668C71.6196 40.8035 73.6449 40.1832 75.8222 40.1832C77.9994 40.1832 80.0247 40.8035 81.7462 41.8668Z",
    fill: "#030822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0874 41.8669C30.6571 42.2214 31.4039 41.8163 31.4039 41.1581V41.1454C31.4039 37.1454 28.1634 33.9049 24.1634 33.9049C20.1634 33.9049 16.9229 37.1454 16.9229 41.1454C16.9229 41.1581 16.9229 41.1581 16.9229 41.1581C16.9229 41.829 17.6697 42.2214 18.2393 41.8669C19.9608 40.8037 21.9861 40.1834 24.1634 40.1834C26.3406 40.1834 28.3659 40.8037 30.0874 41.8669Z",
    fill: "#030822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2905 73.8799C41.1259 73.8799 32.05 70.3356 25.4044 64.1584C24.3158 63.1458 24.2525 61.4622 25.2652 60.3736C26.2652 59.285 27.9614 59.2217 29.05 60.2344C34.7209 65.5002 42.455 68.5255 50.2905 68.5255C57.8474 68.5255 65.3791 65.6901 70.9867 60.728C72.1006 59.7533 73.7841 59.8546 74.7715 60.9559C75.7462 62.0698 75.6449 63.7533 74.5436 64.7407C67.8728 70.6394 59.2652 73.8799 50.2905 73.8799Z",
    fill: "#030822"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.25 40.7692) rotate(96.0235) scale(59.5596 59.5396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854067,
    stopColor: "#FFBB54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#FFDA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854267,
    stopColor: "#FFBB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FFBB54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/Good.4eb7ccab1aee73cfba291f64fcf45241.svg";
export { ForwardRef as ReactComponent };